import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import injectSaga from '../../redux/injectSaga';
import { RESTART_ON_REMOUNT } from '../../redux/sagaInjectors';
import consentSaga from '../../redux/surveys/sagas/consent-saga';
import styles from './index.styl';

export const enhance = compose(
  injectSaga({
    key: 'consentSaga',
    saga: consentSaga,
    mode: RESTART_ON_REMOUNT,
  }),
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/enhance.js